module.exports = __webpack_public_path__ + "img/camera.e43d391.png";